import { Checkbox } from './Checkbox'
import { Email } from './Email'
import { Message } from './Message'
import { Number } from './Number'
import { Select } from './Select'
import { Text } from './Text'
import { Textarea } from './Textarea'

export const fields = {
  checkbox: Checkbox,
  email: Email,
  message: Message,
  number: Number,
  select: Select,
  text: Text,
  textarea: Textarea,
}
